import styled from '@emotion/styled';
import { Button, Form, Input, notification } from 'antd';
import { useState } from 'react';
import { AgenceEntity } from '../../../../entities/agence.entity';
import { UserEntity } from '../../../../entities/utilisateur.entity';
import { ORANGE } from '../../../../shared/colors';
import { createUtilisateur, updateUtilisateur } from '../network';

const FormShell = styled.div`
  color: var(--mt-text);

  .form-intro {
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 14px;
    background:
      linear-gradient(135deg, rgba(255, 79, 31, 0.1), transparent 42%),
      var(--mt-surface);
  }

  .form-intro span {
    color: var(--mt-warning);
    font-family: Poppins-B;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .form-intro h3 {
    margin: 5px 0 0;
    color: var(--mt-text);
    font-family: Poppins-B;
  }

  .ant-form-item-label label {
    color: var(--mt-muted);
    font-family: Poppins-B;
    font-size: 12px;
    text-transform: uppercase;
  }

  .ant-input {
    height: 42px;
    border-color: var(--mt-border);
    border-radius: 8px;
    background: var(--mt-surface);
    color: var(--mt-text);
  }

  .submit-button {
    min-width: 180px;
    height: 42px;
    border: 0;
    border-radius: 999px;
    background: linear-gradient(135deg, ${ORANGE}, #ffb000);
    color: #07141c;
    font-family: Poppins-B;
  }
`;

export const UserForm = ({
  userToUpdate,
  agence,
  setShowDrawer,
  getNewUser,
}: {
  userToUpdate?: UserEntity;
  agence: AgenceEntity;
  setShowDrawer: (b: boolean) => void;
  getNewUser: (part: UserEntity) => void;
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  form.setFieldsValue(userToUpdate);
  return (
    <FormShell>
      <div className='form-intro'>
        <span>{userToUpdate ? 'Modification utilisateur' : 'Nouvel utilisateur'}</span>
        <h3>{userToUpdate ? `${userToUpdate.nom} ${userToUpdate.prenom}` : agence?.nom}</h3>
      </div>
      <Form
        layout='vertical'
        style={{ listStyleType: 'none' }}
        form={form}
        initialValues={userToUpdate}
        labelCol={{ span: 20 }}
        wrapperCol={{ span: 25 }}
        onFinish={async (data) => {
          setIsLoading(true);

          if (userToUpdate === undefined) {
            // create new user
            data.agence = agence.url;
            data.actif = true;

            await createUtilisateur(data).then(({ data, statusCode }) => {
              if (statusCode?.toString()[0] === '2') {
                notification.success({
                  message: 'Succès',
                  description: "L'utilisateur a été créé avec succès",
                });
                getNewUser(data);
                setShowDrawer(false);
              } else {
                notification.info({
                  message: 'Erreur',
                  description: data.message,
                });
              }
              setIsLoading(false);
            });
          } else {
            // update user
            await updateUtilisateur(userToUpdate.url, data).then(
              ({ data, statusCode }) => {
                if (statusCode?.toString()[0] === '2') {
                  notification.success({
                    message: 'Succès',
                    description: "L'utilisateur a été mise à jour avec succès",
                  });
                  setShowDrawer(false);
                } else {
                  notification.info({
                    message: 'Erreur',
                    description: data.message,
                  });
                }
                setIsLoading(false);
              },
            );
          }
        }}
      >
        <Form.Item
          label='Nom'
          name='nom'
          rules={[
            {
              required: true,
              message: 'Entrez le nom',
            },
          ]}
          style={{ marginBottom: 5 }}
        >
          <Input placeholder="Entrez le nom de l'utilisateur" />
        </Form.Item>
        <Form.Item
          label='Prénom'
          name='prenom'
          rules={[
            {
              required: true,
              message: 'Entrez le prénom',
            },
          ]}
          style={{ marginBottom: 5 }}
        >
          <Input placeholder="Entrez le prénom de l'utilisateur" />
        </Form.Item>
        <Form.Item
          label='Email'
          name='email'
          rules={[
            {
              required: true,
              message: 'Entrez une adresse mail valide',
            },
          ]}
          style={{ marginBottom: 5 }}
        >
          <Input placeholder='Entrez une adresse mail valide' />
        </Form.Item>
        <Form.Item
          label='Adresse'
          name='adresse'
          rules={[
            {
              required: true,
              message: "Entrez l'adresse",
            },
          ]}
          style={{ marginBottom: 5 }}
        >
          <Input placeholder="Entrez l'adresse" />
        </Form.Item>
        <Form.Item label='Contact' name='mobile' style={{ marginBottom: 5 }}>
          <Input placeholder='Entrez le contact' />
        </Form.Item>
        <Form.Item
          label='Nationalité'
          name='nationalite'
          rules={[
            {
              required: true,
              message: 'Entrez la nationalité',
            },
          ]}
          style={{ marginBottom: 5 }}
        >
          <Input placeholder='Entrez la nationalité' />
        </Form.Item>
        {!userToUpdate && (
          <Form.Item
            label='Mot de pase par défaut'
            name='password'
            rules={[
              {
                required: true,
                message: 'Entrez la mot de passe',
              },
            ]}
          >
            <Input placeholder='Entrez le mot de passe' />
          </Form.Item>
        )}

        <Form.Item>
          <Button
            className='submit-button'
            htmlType='submit'
            loading={isLoading}
          >
            Enregistrer
          </Button>
        </Form.Item>
      </Form>
    </FormShell>
  );
};
